import React from 'react';
import { Chip, Stack, Typography } from '@mui/material';
import { useNewCampaign } from '../../../../../contexts/NewCampaignContext';

const ColumnsChips = ({ columns = [] }) => {
  const { handleInsertPlaceholder } = useNewCampaign();

  if (columns.length === 0) {
    return (
      <Typography variant="body2" sx={{ mt: 3 }}>
        Your spreadsheet has no columns
      </Typography>
    );
  }

  return (
    <Stack direction="row" spacing={1} sx={{ mt: 3 }}>
      {columns.map((column, index) => (
        <Chip
          key={index}
          label={column.name}
          onClick={() => handleInsertPlaceholder(column.name)}
        />
      ))}
    </Stack>
  );
};

export default ColumnsChips;
